import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=27ff1c98&scoped=true&"
import script from "./CountryFlag.vue?vue&type=script&lang=ts&"
export * from "./CountryFlag.vue?vue&type=script&lang=ts&"
import style0 from "./CountryFlag.vue?vue&type=style&index=0&id=27ff1c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff1c98",
  null
  
)

export default component.exports